
import apiUrl from '../../../../constants'
import axios from 'axios'
import Pagination from './../../shared/pagination'
import {
    Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import download from 'downloadjs';
import Loader from './../../shared/loader'
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
Vue.component("downloadExcel", JsonExcel);
export default {
    name: 'goods-receipt-report',
    components: {
        //Paginate,
        BasicSelect,
        Pagination,
        DatePicker,
        download,
        JsonExcel,
        Loader,
    },
    props: [],
    data() {
        return {
            // currentPage: 0,
            // pageno: 0,
            // pageCount: 0,
            // totalRows:0,
            selectedmerchant: { value: '', text: '' },
            merchantList: [],
            Merchant: '',
            merchantId: '',
            reportname: '',
            csvFieldsForXls: {},
            listReportDataforxls: [],
            currentPage: 1,
            totalPage: 0,
            totalRows: 0,
            pageLimit: 10,

            listGoodsReceiptData: [],
            listMerchantData: [],
            listwarehouseidData: [],
            listGoodsReceiptFinalData: [],
            pono: '',
            supplier: '',
            invoiceno: '',
            fromdate: '',
            todate: '',
            ProductID: '',
            listReportDatacsv: [],
            csvFields: [],
            isLoading: false,
            formattedDate: '',
            warehouseid: '',
            resultCount: '',
            listClientData: [],
            listWarehouseData: [],
            client: '',
            clientid:'',
            warehouse: '',
            warehouseid:'',
            ClientErr: '',
            WarehouseErr: '',
            ClientErr: '',
            merchantid: '',
            searchFlag: false,
            showSelectMerchant: false,
            showSelectWarehouse: false,
            showSelectClient: false,
            user_type: '',
            invreferenceid: '',
            userid: '',
            show: false,
            download: true,
            dataFilter2: '',
            isLoadingforxls: false,
            limitExeed: false,
            recordLimit: 0,
            mid: '',
            brand: '',
            activemrpflag:false,
            searchSLA :'',
            slaclient:[],
			slaflag:false,
            hideGRNExcessQtyFlag:false,
            hideGRNExcessQty:0
        }
    },
    computed: {

    },
    mounted() {
        this.calldateFunction();
        var today = new Date();
        this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss');
        var permissionEncrypt = window.localStorage.getItem('userdetail');
        var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.userid = userdetail.userid;
        this.createdbyEmail = userdetail.email;
        this.reportname = this.$t('editedjson.goodsReceiptReport')
        this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
        this.pageno = 0;
        this.user_type = userdetail.utype;
        this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client

		if(this.clientid!=='undefined'){
			this.getMerchantData();
		}
        var slaconfig = window.localStorage.getItem('slaconfig');
		this.slaclient = JSON.parse(slaconfig);
		console.log(this.slaconfig);

		this.slaflag = this.slaclient.some(item => {
			if (item.clientid == this.clientid) {
			  return true;
			} else {
			  this.slaflag = false;
			  return false;
			}
		  });

        switch (this.user_type) {
            case 'system_user':
                this.showSelectClient = true;
                this.showSelectWarehouse = true;
                this.showSelectMerchant = true;
                // this.getClientList();
                break;
            case 'client_user':
                this.showSelectWarehouse = true;
                this.clientid = userdetail.clientid;
                this.client = this.clientid;
                this.showSelectMerchant = true;
                // this.getWarehouseList();
                this.getMerchantData();
                this.getActiveMrpFlag();
                if (userdetail.merchantid != null) {
                    this.mid = userdetail.merchantid.toString()
                    this.merchantid = this.mid
                    this.showSelectMerchant = false;
                }
                break;

            case 'warehouse_user':
                this.loginUserEmail = userdetail.email;
                this.warehouseid = userdetail.warehouseid;
                this.warehouse = this.warehouseid;
                this.showSelectMerchant = true;
                this.showSelectClient = true;
                // this.getClientList();

                var roleids = userdetail.roleid.split(',');
                for (var i = 0; i < roleids.length; i++) {
                    if (roleids[i] == 40) {
                        this.purchasingManager = parseInt(roleids[i]);
                    }
                    if (roleids[i] == 41) {
                        this.isInwardUserForPO = true;
                    }
                }
                break;

            default:
                this.$alertify.error(this.$t('common.unauthorisedError'));
                break
        }
        this.getRecordLimit()
    },
    methods: {
        selectMerchant(data) {
            this.selectedmerchant = data;
            this.merchantid = data.value;
        },
        calldateFunction: function () {
            this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
            this.todate = this.currentDate;
            var dt = new Date(this.currentDate);
            dt.setDate(dt.getDate() - 6);
            this.fromdate = dt;
        },
        getRecordLimit() {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            this.input = ({

            })
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'getRecordLimit',
                'data': this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            })
                .then(result => {
                    if (result.data) {
                        this.recordLimit = result.data.data;


                    }
                }, error => {
                    console.error(error)
                })
        },
        startDownload() {
            this.isLoadingforxls = true;
        },
        finishDownload() {
            this.isLoadingforxls = false;
        },
        dateFormat1(date) {
            if (!date) return '';
            return moment(date).format('YYYY-MM-DD') + " 00:00:00";
        },
        dateFormat2(date) {
            if (!date) return '';
            return moment(date).format('YYYY-MM-DD') + " 23:59:59";
        },
        Choosetype() {
            this.show = true;
            this.download = false;
            if (!this.limitExeed) {
                this.getGoodsReceiptReportDataForXls(3)

            }
        },
        export(data, filename, mime) {
            let blob = this.base64ToBlob(data, mime)
            download(blob, filename, mime)
        },
        base64ToBlob(data, mime) {
            let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
            let bstr = atob(base64)
            let n = bstr.length
            let u8arr = new Uint8ClampedArray(n)
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n)
            }
            return new Blob([u8arr], {
                type: mime
            })
        },
        getMerchantData() {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            this.input = ({
                clientid: this.clientid,
            });
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'merchantList',
                'data': this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            })
                .then(result => {
                    this.listMerchantData = result.data
                    this.merchantList.push({
                        value: '', text: this.$t('common.selectMerchantPlaceHolder')
                    }
                    )
                    for (var i = 0; i < this.listMerchantData.length; i++) {
                        this.merchantList.push({
                            'value': this.listMerchantData[i].merchantid,
                            'text': this.listMerchantData[i].merchantname
                        });
                    }
                }, error => {
                    console.error(error)
                })
        },
        // getClientList() {
        //     var userToken = window.localStorage.getItem('userToken');
        //     var myStr = userToken.replace(/"/g, '');
        //     this.pageno = 0;
        //     if (window.localStorage.getItem("clientList") !== null) {
        //         var clientListEncrypt = window.localStorage.getItem('clientList');
        //         var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
        //         var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
        //         this.listClientData = JSON.parse(plaintextclient);
        //     } else {
        //         this.input = ({
        //             warehouseid: this.warehouseid,
        //         });
        //         axios({
        //             method: 'POST',
        //             'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
        //             'data': this.input,
        //             headers: {
        //                 'Authorization': 'Bearer ' + myStr,
        //             }
        //         })
        //             .then(result => {
        //                 this.listClientData = result.data.data;
        //             }, error => {
        //                 console.error(error);
        //             });
        //     }
        // },

        // getWarehouseList() {
        //     var userToken = window.localStorage.getItem('userToken')
        //     var myStr = userToken.replace(/"/g, '');
        //     this.pageno = 0;
        //     if (window.localStorage.getItem("warehouseList") !== null) {
        //         var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
        //         var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
        //         var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
        //         this.listWarehouseData = JSON.parse(plaintextwarehouse);
        //     } else {
        //         this.input = ({
        //             clientid: this.clientid,
        //         });
        //         axios({
        //             method: 'POST',
        //             'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
        //             'data': this.input,
        //             headers: {
        //                 'Authorization': 'Bearer ' + myStr
        //             }
        //         })
        //             .then(result => {
        //                 this.listWarehouseData = result.data.data;
        //             }, error => {
        //                 console.error(error)
        //             })
        //     }
        // },
        // clientSelected() {
        //     if (this.clientid != this.client || this.clientid == this.client) {
        //         this.clientid = this.client;
        //         this.merchantid = '';
        //         if (this.clientid) {
        //             this.getMerchantData();
        //         }

        //         if (this.user_type != 'warehouse_user') {
        //             this.listWarehouseData = []
        //             this.getWarehouseList();
        //             this.getActiveMrpFlag();
        //             this.Merchant = ''
        //             this.merchantList = []
        //             this.selectedmerchant = {}
        //             if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
        //                 this.warehouse = this.warehouseid = '';
        //             } else {
        //                 this.warehouse = ''
        //             }
        //         } else {
        //             if (this.warehouseid && this.clientid);
        //             this.getActiveMrpFlag();
        //             this.selectedmerchant = {}
        //             this.Merchant = ''
        //             this.merchantList = []
        //             // this.getGoodsReceiptReportData();
        //         }
        //     }
        //     this.listGoodsReceiptFinalData = [];
        //     this.listGoodsReceiptData = [];
        //     this.listRackinData = [];
        //     this.pageno = this.pageCount = 0;
        // },
        // warehouseSelected() {
        //     this.warehouseid = this.warehouse;
        //     this.pageno = this.pageCount = 0;
        //     if (this.warehouseid) {
        //         if (this.clientid) {

        //         } else {
        //             this.getClientList();
        //         }
        //     }
        //     this.listGoodsReceiptData = [];
        //     this.listGoodsReceiptFinalData = [];
        // },
        async getActiveMrpFlag(){
     				 var userToken = window.localStorage.getItem('userToken');
     				 var myStr = userToken.replace(/"/g, '');
     				 this.input = ({
     					 "clientid": this.clientid,
     				 });
     			 try {

     					 axios({
     							 method: 'POST',
     							 'url': apiUrl.api_url + 'checkActivemrpFlg',
     							 'data': this.input,
     							 headers: {
     								 'Authorization': 'Bearer ' + myStr,
     							 }
     						 })
     						 .then(result => {
     							 if(result.data.data.data[0].value ==='yes'){
     								 this.activemrpflag = true;
     							 }else{
     								 this.activemrpflag = false;
     							 }
     						 }, error => {
     							 console.error(error);
     						 });

     				 } catch (err) {
     					 throw new Error(err);
     				 }
     	 },
        //to get search filter
        getGoodReceiptReportDataSearch() {
            this.currentPage = 1;
            this.pageCount = 0;
            this.searchFlag = true;
            this.getGoodsReceiptReportData(2);
        },


        //to get goods receipt list
        getGoodsReceiptReportData(csvCheck = 0) {
            console.log(this.merchantid)
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            if (window.localStorage.getItem('selectedClient') === 'undefined') {
                this.$alertify.error(this.$t('common.clientError'))
                this.pageno = this.pageCount = 0;
                this.listGoodsReceiptFinalData = [];
                return false;
            }
            if (window.localStorage.getItem('selectedWarehouse') === 'undefined') {
                this.$alertify.error(this.$t('common.warehouseError'))
                this.pageno = this.pageCount = 0;
                this.listGoodsReceiptFinalData = [];
                return false;
            }
            var dataFilter = {};

            if (csvCheck == 2) {
                this.show = false;
                this.download = true;
                this.limitExeed = false;
            }
            var fr_date = '';
            var to_date = '';
            var i = 0;
            var tempClientarray = [];
            var tempfinalArray = [];
            if (this.fromdate) {
                fr_date = this.dateFormat(this.fromdate)
            }
            this.isLoading = true;
            if (this.todate) {
                to_date = this.dateFormat(this.todate)
            } else {
                to_date = this.dateFormat(this.todate)
            }
            if (csvCheck == 2)
                this.pageno = 0;
            this.input = ({
                offset: (this.currentPage - 1) * 10,
                limit: 10,
                fromddate: this.dateFormat1(fr_date),
                todate: this.dateFormat2(to_date),
                invoiceno: this.invoiceno.trim(),
                pono: this.pono.trim(),
                invreferenceid: this.invreferenceid.trim(),
                csvData: csvCheck,
                productid: this.ProductID.trim(),
                clientid: window.localStorage.getItem('selectedClient'),
                warehouseid: window.localStorage.getItem('selectedWarehouse'),
                merchantid: this.merchantid,
                userid: this.userid,
                brand: this.brand.trim(),
                slastatus : this.searchSLA
            })
            Object.entries(this.input).forEach(([k, v]) => {
                let skipkeys = ['offset', 'limit', 'csvData'];
                if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
                    dataFilter[k] = v;
                }
            })
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'GRCReport',
                'data': this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            })
                .then(result => {
                    if (csvCheck == 1) {
                        if (result.data.data.length > 0) {
                            this.listReportDatacsv = [];
                            this.show = true;
                            this.download = false;
                            this.csvFields = {
                                'pono': this.$t('removeHold.poId'),
                                'merchantname': this.$t('warehouseRacks.merchant'),
                                'invoiceno': this.$t('inwardList.invoiceId'),
                                'invreferenceid': this.$t('removeHold.drId'),
                                'productid': this.$t('common.productId'),
                                'eancode': this.$t('inwardList.printData.productDetails.eanCode'),
                                'clientproductid':this.$t('common.clientProductId'),
                                'mrp': this.$t('printProductDetails.mrp'),
                                'activemrp': this.$t('common.activemrp'),
                                'productname':  this.$t('printProductDetails.productName'),
                                'brand': this.$t('common.brand'),
                                'productcategory': this.$t('common.productCategory'),
                                'productsubcategory': this.$t('product.productSubCategory'),
                                'polineno': this.$t('removeHold.poLineNumber'),
                                'quantity': this.$t('removeHold.poLineQty'),
                                'orderedquantity':this.$t('removeHold.invoiceLineQty'),
                                'totalreceivequantity': this.$t('removeHold.totalReceivedQty'),
                                'totalacceptedqty': this.$t('removeHold.totalAcceptedQty'),
                                'rejectedquantity':  this.$t('removeHold.totalRejectedQty'),
                                'storeinquantity': this.$t('editedjson.storeInQuantity'),
                                'rejectstoreinquantity':  this.$t('editedjson.rejectedStoreInQuantity'),
                                'crossdockqty': this.$t('common.crossDockQty'),
                                'shortqty': this.$t('removeHold.shortqty'), 
                                'excessqty': this.$t('removeHold.excessqty'),
                                'drdatetime': this.$t('removeHold.drDatetime'),
                                'grndatetime':  this.$t('removeHold.grnDatetime'),
                                'grcdoneby': this.$t('removeHold.grnDoneby'),
                                'nooflots': this.$t('removeHold.noOfLots'),
                                'rackindate':this.$t('returnReceiptReport.putawayDateAndTime'),
                                'slastatus': this.$t('sla.slastatus'),
                                'breachedby': this.$t('sla.breachedby'),
                                'sladatetime':this.$t('sla.sladatetime')

                            };
                            var dateFilter = [];
                            if(this.activemrpflag === true){
                             var skipFilter = ['count', 'clientid', 'grcno', 'merchantid','breachdurationinmins',];
                             if(this.hideGRNExcessQtyFlag===true && this.hideGRNExcessQty===1){
                                 skipFilter.push('excessqty')
                             }
                           }else {
                             var skipFilter = ['count', 'clientid', 'grcno', 'merchantid','activemrp','breachdurationinmins'];
                             if(this.hideGRNExcessQtyFlag===true && this.hideGRNExcessQty===1){
                                skipFilter.push('excessqty')
                            }
                            
                           }
                           if (!this.slaflag) {
                                const keysToAdd = ['slastatus','breachedby','sladatetime'];
                                keysToAdd.forEach(key => {
                                if (!skipFilter.includes(key)) {
                                    skipFilter.push(key);
                                }
                                });
                            }
                            for (i = 0; i < this.listMerchantData.length; i++) {
                                tempClientarray[this.listMerchantData[i].merchantid] = this.listMerchantData[i].merchantname;
                            }
                            for (i = 0; i < result.data.data.length; i++) {
                                tempfinalArray = [];
                                tempfinalArray = result.data.data[i];
                                if (!result.data.data[i].merchantid) {
                                    tempfinalArray["merchantid"] = '';
                                } else {
                                    tempfinalArray["merchantid"] = tempClientarray[result.data.data[i].merchantid];
                                }
                                this.listReportDatacsv.push(tempfinalArray);
                            }
                            console.log(this.listReportDatacsv);
                            csvHelper.data.jsonToCSV(this.$t('editedjson.goodsReceiptReport'), this.listReportDatacsv, this.csvFields, dateFilter, skipFilter, dataFilter);

                            // this.jsonToCSV('GoodsReceiptReport', this.listReportDatacsv, this.csvFields, dateFilter, skipFilter);
                        } else {
                            if (result.data.status == true) {
                                this.$alertify.success(this.$t('common.reportSizeError'));
                            } else {
                                this.$alertify.error(result.data.msg.message);
                            }
                        }
                    } else {
                        this.listGoodsReceiptFinalData = [];
                        this.listGoodsReceiptData = result.data.data
                        if(result.data.hideGRNExcessQty!==undefined){
                            this.hideGRNExcessQtyFlag=true;
                            this.hideGRNExcessQty=result.data.hideGRNExcessQty
                        }else{
                            this.hideGRNExcessQtyFlag=false;
                        }
                        for (i = 0; i < this.listMerchantData.length; i++) {
                            tempClientarray[this.listMerchantData[i].merchantid] = this.listMerchantData[i].merchantname;
                        }
                        for (i = 0; i < this.listGoodsReceiptData.length; i++) {
                            tempfinalArray = [];
                            tempfinalArray = this.listGoodsReceiptData[i];

                            if (this.listGoodsReceiptData[i].merchantid == "") {
                                tempfinalArray["merchantid"] = '';
                            } else {
                                tempfinalArray["merchantid"] = tempClientarray[this.listGoodsReceiptData[i].merchantid];
                            }
                            this.listGoodsReceiptFinalData.push(tempfinalArray);
                        }
                        if (result.data.errorCode == -1) {
                            this.resultCount = 0
                            this.totalRows = 0;
                        } else {
                            this.totalRows = Number(result.data.count)
                            if (Number(this.totalRows) > Number(this.recordLimit)) {
                                this.limitExeed = true
                            }
                            this.resultCount = result.data.count
                            if (this.totalRows < 10) {
                                this.totalPage = 1
                            } else {
                                this.totalPage = Math.ceil(this.totalRows / 10)
                            }
                        }
                    }
                    this.isLoading = false;
                }, error => {
                    console.error(error)
                })
        },
        //to get pagination
        // getPaginationData(currentPage) {
        //  this.pageno = (currentPage - 1) * 10
        //  this.getGoodsReceiptReportData();
        // },
        getGoodsReceiptReportDataForXls(csvCheck = 0) {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            this.show = true;
            this.download = false;
            this.dataFilter2 = [];
            var value = '';
            var str = '';

            var fr_date = '';
            var to_date = '';
            var i = 0;
            var tempClientarray = [];
            var tempfinalArray = [];
            if (this.fromdate) {
                fr_date = this.dateFormat(this.fromdate)
            }
            if (this.todate) {
                to_date = this.dateFormat(this.todate)
            } else {
                to_date = this.dateFormat(this.todate)
            }
            if (csvCheck == 2)
                this.pageno = 0;
            this.input = ({
                offset: (this.currentPage - 1) * 10,
                limit: 10,
                fromddate: this.dateFormat1(fr_date),
                todate: this.dateFormat2(to_date),
                invoiceno: this.invoiceno.trim(),
                pono: this.pono.trim(),
                invreferenceid: this.invreferenceid.trim(),
                csvData: csvCheck,
                productid: this.ProductID.trim(),
                clientid: this.clientid,
                warehouseid: window.localStorage.getItem('selectedWarehouse'),
                merchantid: this.merchantid,
                userid: this.userid,
                brand: this.brand.trim(),
                slastatus : this.searchSLA
            })
            Object.entries(this.input).forEach(([k, v]) => {
                let skipkeys = ['offset', 'limit', 'csvData'];
                if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
                    value += k + ':' + v + ','
                    this.dataFilter2 = str.concat(value);

                }
            })
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'GRCReport',
                'data': this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            })
                .then(result => {
                    if (csvCheck == 3) {
                        if (result.data.data.length > 0) {
                            this.listReportDataforxls = [];
                            this.csvFieldsForXls =[];
                            if(result.data.hideGRNExcessQty!==undefined){
                                this.hideGRNExcessQtyFlag=true;
                                this.hideGRNExcessQty=result.data.hideGRNExcessQty
                            }else{
                                this.hideGRNExcessQtyFlag=false;
                            }
                            this.csvFieldsForXls[ this.$t('removeHold.poId')] = 'pono';
                            this.csvFieldsForXls[ this.$t('warehouseRacks.merchant')] = 'merchantname';
                            this.csvFieldsForXls[ this.$t('inwardList.invoiceId')] = 'invoiceno';
                            this.csvFieldsForXls[ this.$t('removeHold.drId')] = 'invreferenceid';
                            this.csvFieldsForXls[ this.$t('common.productId')] = 'productid';
                            this.csvFieldsForXls[ this.$t('inwardList.printData.productDetails.eanCode')] =  'eancode';
                            this.csvFieldsForXls[this.$t('common.clientProductId')]='clientproductid'
                            this.csvFieldsForXls[ this.$t('printProductDetails.mrp')] = 'mrp';
                            if(this.activemrpflag === true){
                            this.csvFieldsForXls[ this.$t('common.activemrp')] = 'activemrp';
                           }
                            this.csvFieldsForXls[ this.$t('printProductDetails.productName')] = 'productname';
                            this.csvFieldsForXls[ this.$t('common.brand')] =  'brand';
                            this.csvFieldsForXls[ this.$t('common.productCategory')] =  'productcategory';
                            this.csvFieldsForXls[ this.$t('product.productSubCategory')] = 'productsubcategory';
                            this.csvFieldsForXls[ this.$t('removeHold.poLineNumber')] = 'polineno';
                            this.csvFieldsForXls[ this.$t('removeHold.poLineQty')] = 'quantity';
                            this.csvFieldsForXls[ this.$t('removeHold.invoiceLineQty')] = 'orderedquantity';
                            this.csvFieldsForXls[ this.$t('removeHold.totalReceivedQty')] =  'totalreceivequantity';
                            this.csvFieldsForXls[ this.$t('removeHold.totalAcceptedQty')] = 'totalacceptedqty';
                            this.csvFieldsForXls[ this.$t('removeHold.totalRejectedQty')] = 'rejectedquantity';
                            this.csvFieldsForXls[ this.$t('editedjson.storeInQuantity')] = 'storeinquantity';
                            this.csvFieldsForXls[ this.$t('editedjson.rejectedStoreInQuantity')] = 'rejectstoreinquantity';
                            this.csvFieldsForXls[this.$t('common.crossDockQty')] = 'crossdockqty';
                            this.csvFieldsForXls[ this.$t('removeHold.shortqty')]='shortqty';
                            if(this.hideGRNExcessQtyFlag===true && this.hideGRNExcessQty===0){
                            this.csvFieldsForXls[ this.$t('removeHold.excessqty')]='excessqty';
                            }
                            this.csvFieldsForXls[ this.$t('removeHold.drDatetime')] = 'drdatetime';
                            this.csvFieldsForXls[ this.$t('removeHold.grnDatetime')] = 'grndatetime';
                            this.csvFieldsForXls[ this.$t('removeHold.grnDoneby')] = 'grcdoneby';
                            this.csvFieldsForXls[ this.$t('removeHold.noOfLots')] = 'nooflots';
                            this.csvFieldsForXls[ this.$t('returnReceiptReport.putawayDateAndTime')]='rackindate';
                            this.csvFieldsForXls[ this.$t('sla.slastatus')] = 'slastatus';
                            this.csvFieldsForXls[this.$t('sla.breachedby')]='breachedby';
                            this.csvFieldsForXls[this.$t('sla.sladatetime')]='sladatetime';
                            const keysToRemove = [ this.$t('sla.slastatus'), this.$t('sla.breachedby'),this.$t('sla.sladatetime')];
							if (!this.slaflag) {
							  keysToRemove.forEach(key => {
								if (this.csvFieldsForXls.hasOwnProperty(key)) {
								  delete this.csvFieldsForXls[key];
								}
							  });
							}


                            for (i = 0; i < this.listMerchantData.length; i++) {
                                tempClientarray[this.listMerchantData[i].merchantid] = this.listMerchantData[i].merchantname;
                            }
                            for (i = 0; i < result.data.data.length; i++) {
                                tempfinalArray = [];
                                tempfinalArray = result.data.data[i];
                                if (!result.data.data[i].merchantid) {
                                    tempfinalArray["merchantid"] = '';
                                } else {
                                    tempfinalArray["merchantid"] = tempClientarray[result.data.data[i].merchantid];
                                }
                                this.listReportDataforxls.push(tempfinalArray);
                            }
                        } else {
                            if (result.data.status == true) {
                                this.$alertify.success(this.$t('common.reportSizeError'));
                            } else {
                                this.$alertify.error(result.data.msg.message);
                            }
                        }


                    }


                }, error => {
                    console.error(error)
                })
        },
        onPageChange(page) {
            this.currentPage = page;
            this.getGoodsReceiptReportData()
        },

        dateFormat(date) {
            if (!date) return '';
            return moment(date).format('YYYY-MM-DD');
        },

        //to reset search form
        resetSearchForm() {
            this.brand = '',
                this.show = false;
            this.download = true;
            this.fromdate = '';
            this.todate = '';
            this.invoiceno = '';
            this.pono = '';
            this.supplier = '';
            this.ProductID = '';
            this.merchantid = '';
            this.totalRows = 0;
            this.searchFlag = false;
            this.invreferenceid = '';
            this.listGoodsReceiptFinalData = [];
            this.selectedmerchant = {}
            this.searchSLA=''
            // if (this.user_type == 'warehouse_user') {
            //     this.client = '';
            //     // this.merchantList = []
            // }
            // else if (this.user_type == 'client_user')
            //     this.warehouse = '';
            // else {
            //     this.client = '';
            //     this.warehouse = '';
            //     // this.merchantList = []
            // }
        },
        //validate all form fields on onsubmit()
        onSubmit: function (event) {
            this.$validator.validateAll().then(() => {
                event.target.reset();
                console.log('form is valid', this.model)
            }).catch(() => {
                console.log('errors exist', this.errors)
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/components/reports/goodsReceiptReport/goodsReceiptReport.component.js